var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAICustomService)?_c('div',{staticClass:"humanService",attrs:{"id":"draggable"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }